// Rótulo de exibição de um circuito: nome próprio quando houver, genérico por posição quando não.
// O genérico é retrocompatível: circuito antigo e circuito criado por rotina do ERP têm nome null.
export default function labelCircuito(circuito, index) {
  const nome = circuito?.nome?.trim?.();
  return nome || `Circuito ${(index ?? 0) + 1}`;
}
